import { Row, Col } from "react-bootstrap";
import CustomerSidebar from "../../layouts/customer/CustomerSidebar";
import CustomerHeader from "../../layouts/customer/CustomerHeader";
import "../../assets/css/layout/customer/CustomerLayout.css";

const CustomerLayout = ({ children }) => {
  return (
    <div className="customer-layout-container-csl">
      
      {/* FIXED SIDEBAR */}
      <div className="customer-sidebar-wrapper-csl">
        <CustomerSidebar />
      </div>

      {/* MAIN CONTENT AREA */}
      <div className="customer-main-content-csl sidebar-open-csl">
        {/* STICKY HEADER */}
        <div className="customer-header-wrapper-csl">
          <CustomerHeader />
        </div>

        {/* SCROLLABLE CONTENT */}
        <div className="customer-content-area-csl">
          {children}
        </div>

        {/* FOOTER */}
        {/* <div className="customer-footer-csl">
          <p className="footer-text-csl">
            © 2026 Event Management. All rights reserved.
          </p>
        </div> */}
      </div>

    </div>
  );
};

export default CustomerLayout;